import * as PIXI from 'pixi.js';
import { tooltipCursor } from '__common/models/cursorTooltip';
import { state } from '__common/store';

export const drawTooltipCursorOnStage = (renderer: PIXI.Renderer, stage: PIXI.Container, event?: any) => {
  const { tooltipCursor: { content, position } } = state();
  let tooltipPosition;

  // Remove existing tooltip cursor if it exists
  const existingTooltip = stage.children.find(child => child.id === 'cursorTooltip');
  if (existingTooltip) {
    stage.removeChild(existingTooltip);
  }
  
  if (!content) {
    return;
  }

  if (position) {
    tooltipPosition = position;
  } else {
    tooltipPosition = getDefaultCursorPosition(renderer, stage, event);
  }

  const { x, y } = tooltipPosition;
  const tooltip = tooltipCursor(stage, x, y, content);
  stage.addChild(tooltip);
};

function getDefaultCursorPosition(renderer: PIXI.Renderer, stage: PIXI.Container, event?: any) {
  // If we have an event object, use it to get the cursor position
  if (event && event.data && event.data.global) {
    const coords = stage.toLocal(event.data.global);
    return {
      x: coords.x,
      y: coords.y,
    };
  }
  
  // Fallback: use cursor position from state
  const currentState = state();
  if (currentState.editorCursor && currentState.editorCursor.position) {
    return currentState.editorCursor.position;
  }
  
  return {
    x: 0,
    y: 0,
  };
}

